module.exports = __webpack_public_path__ + "img/red-cell.78832227.svg";